<template>
<div class="grid" >
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-3">
<div class="grid"  v-click-away="cancel">
<div class="col">




<FileUpload name="files[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="">
  <template #empty>
      <p>Dosyayı sürükleyip bırakın</p>
  </template>
</FileUpload>


</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-9 md:col-10">
  <div class="grid">
    <div class="col-10"  @click="edit">
      <p class="click_edit_value animate_class">
        {{value}}
        </p>
    </div>

    <div class="col-2">
      <Button type="button"  v-if="value" icon="pi pi-file-o"  class="p-button-primary p-button-outlined p-button-sm mt-3"  @click="openPlayerModal" />
    </div>


  </div>


</div>
</template>
<VideoPlaybackModal  ref="videoplaybackmodal"></VideoPlaybackModal>
</div>	
</template>

<script>
import VideoPlaybackModal from "./VideoPlaybackModal"
export default {

  name: 'ClickEditUpload',
  props:["title","value","valkey","filepath"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
      files:[],
      videooptions:null,
    }
  },
  components: {VideoPlaybackModal},
  computed:{

  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		 console.log("value change");
  		 this.editing = false
  	}
  },
  methods:{
    openPlayerModal()
    {      
      this.$refs.videoplaybackmodal.open(this.filepath,this.value)
    },
    onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
      this.submitChanges()
    },
  	submitChanges()
  	{

  		if(this.files.length)
  		{
  			this.$emit("dataChanged",{value:this.files,key:this.valkey})
  			this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
  		this.editing = true
  		this.inputdata = this.value
  		
  		setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>